var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.pricesFetched)?_c('span',[(_vm.showBargainPrice)?_c('del',[_vm._v(_vm._s(_vm._f("formatCurrency")(_vm.updatedPrice,_vm.prices.currency, _vm.prices.locale)))]):_c('span',[_vm._v(_vm._s(_vm._f("formatCurrency")(_vm.updatedPrice,_vm.prices.currency, _vm.prices.locale, { style: 'decimal' })))])]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }